import {
  GET_CONTRACT_INVOICES,
  GET_CONTRACT_INVOICES_RESPONSE,
  GET_CONTRACT_INVOICES_FAIL,
  GET_CONTRACT_INVOICE_ACCOUNTS,
  GET_CONTRACT_INVOICE_ACCOUNTS_RESPONSE,
  GET_CONTRACT_INVOICE_ACCOUNTS_FAIL,
} from "./actions";

const initialState = {
  isLoading: false,
  error: null,
  contractInvoices: [],
  contractInvoiceAccounts: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CONTRACT_INVOICES:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };

    case GET_CONTRACT_INVOICES_RESPONSE:
      return {
        ...state,
        contractInvoices: Array.isArray(action.contractInvoices) ? action.contractInvoices : [],
        error: null,
        isLoading: false,
      };

    case GET_CONTRACT_INVOICES_FAIL:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };

    case GET_CONTRACT_INVOICE_ACCOUNTS:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };

    case GET_CONTRACT_INVOICE_ACCOUNTS_RESPONSE:
      return {
        ...state,
        contractInvoiceAccounts: Array.isArray(action.contractInvoiceAccounts) ? action.contractInvoiceAccounts : [],
        error: null,
        isLoading: false,
      };

    case GET_CONTRACT_INVOICE_ACCOUNTS_FAIL:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };

    default:
      return state;
  }
};
